<template>
  <div id="timemaria">
    <div class="section-header">
      <h3>Coordenação</h3>
    </div>

    <b-row fluid align-content="stretch"  align-h="center" align-v="center" > <!--class="justify-content-lg-center"-->
      <!-- <b-col col lg="3" md="4" sm="8" cols="10"> 
        <div id="time_img1" class="member">
          <img src="../img/timemaria/partner_Isabela.jpg" class="img-fluid" alt>
          <div class="member-info">
            <div class="member-info-content">
              <h4>Isabelle Dorociaki de Oliveira</h4>
              <span>Professora</span>
            </div>
          </div>
        </div>
      </b-col> -->
      
      <b-col col lg="3" md="4" sm="8" cols="10">
        <div id="time_img2" class="member">
          <img src="../img/timemaria/partner_Karinna.jpg" class="img-fluid" alt>
          <div class="member-info">
            <div class="member-info-content">
              <h4>Karinna Senger</h4>
              <span>Sócia-Professora</span>
            </div>
          </div>
        </div>
      </b-col>

      <b-col col lg="3" md="4" sm="8" cols="10">
        <div id="time_img3" class="member">
          <img src="../img/timemaria/partner_Luana.jpg" class="img-fluid" alt="image1">
          <div class="member-info">
            <div class="member-info-content">
              <h4>Luana Passos Bertoldi</h4>
              <span>Sócia-Professora</span>
            </div>
          </div>
        </div>
      </b-col>
    
    </b-row>
  </div>
</template>

<script>

export default {
  name: "MeuTime",
  data() {
    return {
      mostrar: false
    };
  },
  methods: {
    animationElement(posEl, isMostrar) {
      // let elImg1 = document.querySelector('#time_img1')
      let elImg2 = document.querySelector('#time_img2')
      let elImg3 = document.querySelector('#time_img3')
      if (isMostrar) {
        // elImg1.classList.add('animate__animated', 'animate__fadeInDownBig')
        // elImg1.style.setProperty('--animate-duration', '0.5s')
        elImg2.classList.add('animate__animated', 'animate__fadeInDownBig')
        elImg2.style.setProperty('--animate-duration', '0.7s')
        elImg3.classList.add('animate__animated', 'animate__fadeInDownBig')
        elImg3.style.setProperty('--animate-duration', '0.9s')
      } else {
        // elImg1.classList.remove('animate__animated', 'animate__fadeInDownBig')
        elImg2.classList.remove('animate__animated', 'animate__fadeInDownBig')
        elImg3.classList.remove('animate__animated', 'animate__fadeInDownBig')
      }
    }
  }
};
</script>

<style scoped>

#timemaria {
  padding: 60px 0;
}

#timemaria .b-row {
  /* Distribui uniformemente as colunas dentro do espaço */
  justify-content: space-around;
  gap: 20px; /* Espaçamento entre as colunas */
}

#timemaria .member {
  text-align: center;
  margin: 0 auto; 
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
}

#timemaria .member img {
  width: 100%;
  height: auto;
}

#timemaria .member .member-info {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  transition: 0.2s;
  padding: 15px 0;
  background: rgba(29, 28, 41, 0.6);
}

#timemaria .member .member-info-content {
  transition: margin 0.2s;
  height: 40px;
  transition: height 0.4s;
}

#timemaria .member:hover .member-info {
  transition: 0.4s;
}

#timemaria .member:hover .member-info-content {
  height: 80px;
}

#timemaria .member h4 {
  font-weight: 700;
  margin-bottom: 2px;
  font-size: 18px;
  color: #fff;
}

#timemaria .member span {
  font-style: italic;
  display: block;
  font-size: 13px;
  color: #fff;
}

#timemaria .member .social {
  margin-top: 15px;
}

#timemaria .member .social a {
  transition: none;
  color: #fff;
}

#timemaria .member .social a:hover {
  color: #1bb1dc;
}

#timemaria .member .social i {
  font-size: 18px;
  margin: 0 2px;
}


</style>



// WEBPACK FOOTER //
// src/views/meutime.vue